/** how often to send page events */
export const UPDATE_PERIOD = 300;
//# sourceMappingURL=options.js.map